/**
 * AI 分析 - 风险提示
 */
import React from 'react';
import { Card, Space, Alert, Typography, Tag } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

interface Risk {
  title: string;
  description: string;
  severity: string;
  mitigation: string;
}

interface AIRisksProps {
  risks: Risk[];
}

export const AIRisks: React.FC<AIRisksProps> = ({ risks }) => {
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case '高':
        return 'red';
      case '中':
        return 'orange';
      case '低':
        return 'green';
      default:
        return 'default';
    }
  };

  const getAlertType = (severity: string): 'error' | 'warning' | 'info' => {
    if (severity === '高') return 'error';
    if (severity === '中') return 'warning';
    return 'info';
  };

  return (
    <Card
      title={
        <Space>
          <SafetyOutlined style={{ color: '#ff4d4f' }} />
          风险提示
        </Space>
      }
      className="ai-content-card"
    >
      {risks.map((risk, index) => (
        <Alert
          key={index}
          className="risk-alert"
          message={
            <Space>
              <Tag color={getSeverityColor(risk.severity)}>{risk.severity}风险</Tag>
              <span style={{ fontWeight: 600 }}>{risk.title}</span>
            </Space>
          }
          description={
            <div>
              <Paragraph style={{ margin: '8px 0' }}>{risk.description}</Paragraph>
              <div className="risk-mitigation">
                <Text strong style={{ color: '#52c41a' }}>
                  ✓ 应对措施:{' '}
                </Text>
                <Text>{risk.mitigation}</Text>
              </div>
            </div>
          }
          type={getAlertType(risk.severity)}
          showIcon
        />
      ))}
    </Card>
  );
};

